import { render, staticRenderFns } from "./AlternativeEmptyTable.vue?vue&type=template&id=3d584b13&scoped=true"
import script from "./AlternativeEmptyTable.vue?vue&type=script&lang=js"
export * from "./AlternativeEmptyTable.vue?vue&type=script&lang=js"
import style0 from "./AlternativeEmptyTable.vue?vue&type=style&index=0&id=3d584b13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d584b13",
  null
  
)

export default component.exports